import React, { useEffect } from "react";
import { Users } from "lucide-react";
import { useLocation } from "react-router-dom";

import BasePage from "../basePage";
import { CrmPetController } from "../../services/controllers/crmPet";

import { CrmPetFilter } from "./CrmPetFilter";
import { CrmPetSummary } from "./CrmPetSummary";
import { CrmPetTable } from "./CrmPetTable";
import { CrmPetTabs } from "./CrmPetTabs";
import { ConfigModal } from "./Modals/ConfigModal";
import { ContactHistoryModal } from "./Modals/ContactHistoryModal";
import { Container } from "./styles";

export function CrmPet() {
  const controller = CrmPetController();
  const location = useLocation();

  useEffect(() => {
    controller.syncRuleFromUrl();
  }, [controller, location.search]);

  return (
    <BasePage pageTitle={<span style={{ display: "flex", alignItems: "center", gap: 8 }}><Users className='w-6 h-6' />CRM</span>}>
      <Container>
        <CrmPetFilter />
        <CrmPetTabs />
        <CrmPetSummary />
        <CrmPetTable />
      </Container>
      <ConfigModal />
      <ContactHistoryModal />
    </BasePage>
  );
}

export default CrmPet;
